<!--西瑞的组播-->
<template>
	<treeBody>
		<listView slot="tree" :dataList='queueTree' @checkItem="nowGroup = $event" :autoCheckIndex='0'></listView>
		<div slot="body">
			<div class="buttonLine">
				<iconButton icoName="wedoButton/send.png" buttonText="下发组播" @buttonClick="sendCommand"></iconButton>
				<iconButton icoName="wedoButton/confirm.png" buttonText="全开" @buttonClick="checkAll(0)" v-if="nowGroup!=undefined && nowGroup.isPublic == -1"></iconButton>
				<iconButton icoName="wedoButton/close.png" buttonText="全关" @buttonClick="checkAll(1)" v-if="nowGroup!=undefined && nowGroup.isPublic == -1"></iconButton>
				<iconButton icoName="wedoButton/add.png" buttonText="添加项" @buttonClick="addDevice" v-if="nowGroup != undefined"></iconButton>
				<iconButton icoName="wedoButton/delete.png" buttonText="删除项" @buttonClick="deleteDevice" v-if="nowGroup != undefined"></iconButton>
				<iconButton icoName="wedoButton/add.png" buttonText="添加组播" @buttonClick="addGroup(-4)"></iconButton>
				<iconButton icoName="wedoButton/delete.png" buttonText="删除组播" @buttonClick="deleteGroup" v-if="nowGroup != undefined"></iconButton>
			</div>
			<infoList ref="castList" style="height: calc(100% - 0.5rem)" :columns='columns' :dataList="multicastList" :pageLen='multicastList.length < 20 ? 20 : multicastList.length'
			 :totalSize="multicastList.length" :fillAll="true" :showIndex="false" @checkItem="nowCast = $event">
				<template slot="operationName" slot-scope="slotProps">
					<div class="flexCenter" v-if="slotProps.item!=undefined">
						<label :class="['flexCenter',{isGreen:isOpen(slotProps.item)}]" style="cursor: pointer;padding: 5px 20px;"><input
							 type="radio" :name="slotProps.item.id" :checked="isOpen(slotProps.item)" value="1" @click="checkItem(slotProps.item,1)">
							开启</label>
						<label :class="['flexCenter',{isRed: !isOpen(slotProps.item)}]" style="margin-left: 10px;padding: 5px 20px;cursor: pointer;"><input
							 type="radio" :name="slotProps.item.id" :checked="!isOpen(slotProps.item)" value="0" @click="checkItem(slotProps.item,0)">关闭</label>
					</div>
				</template>
			</infoList>
		</div>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import listView from '@/components/module/selection/base/listView.vue'
	export default {
		components: {
			treeBody,
			infoList,
			iconButton,
			listView
		},
		props: {},
		data() {
			return {
				nowGroup: undefined,
				queueTree: [],
				nowCast: undefined,
				nowVariable: undefined,
				lastSendTime: 0,
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.refresh()
		},
		destroyed() {},
		computed: {
			columns() {
				if(this.nowGroup == undefined) {
					return [{
						name: '操作项名称',
						key: 'name'
					}, {
						name: '操作内容',
						key: 'operationName',
					}]
				}
				if(this.nowGroup.isPublic == -4) {
					return [{
						name: '操作项名称',
						key: 'deviceName'
					}, {
						name: '操作内容',
						key: 'operationName',
						type: 'slot'
					}]
				}
			},
			multicastList() {
				if(isempty(this.nowGroup)) {
					return []
				}
				var list = this.nowGroup.next.map(item => {
					item.operationName = item.name
					return item
				})
				//排序
				return list.sort((a, b) => {
					return a.name > b.name ? 1 : -1
				})
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			switchTree() {
				return this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos("232,320", this.nowUnit.id)
			},
			switchInfoMap() {
				var result = {}
				//循环预取一下变量
				var list = treeToList(this.switchTree)
				for(var i = 0, len = list.length; i < len; i++) {
					var map = {}
					var item = list[i]
					if(item.entityName == "VirtualDevicePojo") {
						this.$set(map, "320", this.$store.variableStore.getters.getTargetApptypeVariableList(item.no, 320)[0])
						this.$set(map, "232", this.$store.variableStore.getters.getTargetApptypeVariableList(item.no, 232)[0])
						this.$set(map, "deviceList", this.$store.deviceStore.getters.getDeviceListByVirtualDeviceNo(item.no))
						if(!isempty(map.deviceList)) {
							this.$set(map, "config", this.$store.deviceCollectionStore.getters.getConfigByDeviceId(map.deviceList[0].no, map
								.deviceList[0].parentarea))
						}
						if(!isempty(map.config)) {
							this.$set(map, "tagObject", JSON.parse(map.config.tag))
						}
					}
					this.$set(result, item.no, map)
				}
				return result
			},
			isOpen() {
				return item => {
					switch(item.deviceCollectionType) {
						case 'mantunsciUDP':
							return item.command.startsWith("A1")
							break
						case 'mantunsciHTTP':
							return item.command == 'open'
							break
					}
					return true
				}
			}
		},
		watch: {
			switchInfoMap(nv, ov) {

			},
		},
		methods: {
			refresh() {
				this.$api.queueGroupApi.searchQueueGroupTree(respon => {
					this.queueTree = respon
				})
			},
			addGroup(type) {
				this.$dialogMethod.openNomalInputDialog('创建开关组播', [{
					pkid: 'name',
					name: '组播名称'
				}], respon => {
					//-1开关 -2空调遥控  -3空调权限 -4西瑞组播 后面再改现在凑合
					this.$api.queueGroupApi.addQueueGroup(respon.name, type, res => {
						this.$dialogMethod.showMessage('创建成功!')
						res.next = []
						this.queueTree.push(res)
					})
				})
			},
			deleteGroup() {
				this.$dialogMethod.openAgreeDialog("删除当前组播", "是否删除当前组播【{0}】，操作不可还原请谨慎决定！".format(this.nowGroup.name), respon => {
					this.$api.queueGroupApi.deleteQueueGroupById(this.nowGroup.id, respon => {
						this.$dialogMethod.showMessage('删除成功!')
						this.queueTree = this.queueTree.filter(item => item.id != this.nowGroup.id)
						this.nowGroup = this.queueTree[0]
					})
				})
			},
			addDevice() {
				var apptype = 232
				if(this.nowGroup.isPublic != -4) {
					return
				}
				this.$dialogMethod.getMultipleSelectionDialog().setGetIdMethod(item => item.next == undefined ? item.id : 'group' +
					item.id)
				this.$dialogMethod.openMultipleSelectionDialog('请选择设备', [this.switchTree], undefined,
					respon => {
						var deviceList = respon.filter(item => item.entityName == "VirtualDevicePojo")
						this.$dialogMethod.showLoading("正在添加。。。")
						//各自取下面一个第一个控制的变量
						var list = []
						for(var i = 0, len = deviceList.length; i < len; i++) {
							var item = deviceList[i]
							var info = this.switchInfoMap[item.no]
							var commandObject = {
								deviceName: item.name,
							}
							//默认都是开
							if(info.config != undefined) {
								switch(info.config.deviceCollectionType) {
									case "mantunsciUDP":
										if(info[320] != undefined) {
											commandObject.variableName = info[320].fromName
											commandObject.command = "A1;" + info.tagObject.serverInfo.point
										}
										break
									case "mantunsciHTTP":
										if(info[232] != undefined) {
											commandObject.variableName = info[232].fromName
											commandObject.command = "open"
										}
										break
								}
							}
							list.push(commandObject)
						}
						this.$api.queueGroupApi.addJavaQueueItemByVariableNameAndValue(this.nowGroup.id, JSON.stringify(list), respon => {
							this.$dialogMethod.closeLoading()
							this.$dialogMethod.showMessage(respon)
							this.$api.queueGroupApi.searchQueueGroupTreeByPkid(this.nowGroup.id, res => {
								this.nowGroup = res
								this.$set(this.queueTree, this.queueTree.findIndex(item => item.id == res.id), res)
							})
						}, respon => {
							this.$dialogMethod.showMessage("添加失败!")
						})
					})
			},
			sendCommand() {
				if(isempty(this.nowGroup)) {
					this.$dialogMethod.showMessage('请先选中一个操作项！')
					return
				}
				if(Date.now() - this.lastSendTime < 30 * 1000) {
					this.$dialogMethod.showMessage('每个组播之间必须间隔30秒以上！')
					return
				}
				this.$dialogMethod.openAgreeDialog("组播", "确定要下发组播【{0}】吗？共计【{1}】个指令".format(this.nowGroup.name, this.nowGroup.next.length), respon => {
					this.lastSendTime = Date.now()
					//判断下发情况
					this.$api.queueGroupApi.sendQueueGroup(this.nowGroup.id)
					/*this.showProgress(this.nowGroup.next.length)*/
					this.$dialogMethod.showMessage("命令已下发")
				})
			},
			showProgress(length) {
				if(length == 0) {
					this.$dialogMethod.openCircleProgressDialog('指令下发完成', 100)
					return
				}
				var count = 0
				this.$dialogMethod.openCircleProgressDialog('正在建立连接...', 0)
				count++
				var inter = setInterval(() => {
					this.$dialogMethod.openCircleProgressDialog('正在下发指令({0}/{1})'.format(count, length),
						parseInt(count / length * 100))
					if(count >= length) {
						this.$dialogMethod.openCircleProgressDialog('指令下发完成', 100)
						clearInterval(inter)
						setTimeout(() => {
							this.$dialogMethod.closeCircleProgressDialog()
						}, 1500)
					}
					count++
				}, 3000)
			},
			checkItem(item, target) {
				switch(item.deviceCollectionType) {
					case 'mantunsciUDP':
						if(target == 1) {
							item.command = item.command.replace("A2;", "A1;")
						} else {
							item.command = item.command.replace("A1;", "A2;")
						}
						break
					case 'mantunsciHTTP':
						item.command = target == 1 ? 'open' : 'close'
						break
				}
				this.$api.queueGroupApi.updateQueueGroupJavaItem(item.queueGroupId, item.deviceId, item.command)
			},
			deleteDevice() {
				if(isempty(this.nowCast)) {
					this.$dialogMethod.showMessage('请先选择一个操作项')
					return
				}
				this.$api.queueGroupApi.deleteQueueGroupJavaItem(this.nowCast.queueGroupId, this.nowCast.deviceId, respon => {
					this.$delete(this.nowGroup.next, this.nowGroup.next.findIndex(item => item.id == this.nowCast.id))
					this.$dialogMethod.showMessage('删除成功!')
				})
			},
			checkAll(target) {
				var ids = []
				var nIds = []
				for(var i = 0, len = this.multicastList.length; i < len; i++) {
					var item = this.multicastList[i]
					var nItem = item.next.find(it => it.endstatus == target)
					if(nItem != undefined) {
						if(nItem.endstatus != item.endState) {
							ids.push(item.queueGroupItemId)
							nIds.push(nItem.no)
						}
						this.$set(item, 'operationNo', nItem.no)
						this.$set(item, 'operationName', nItem.name)
						this.$set(item, 'endState', nItem.endstatus)
					}
				}
				if(ids.length != 0) {
					this.$api.queueGroupApi.updateQueueGroupItem(ids.join(','), undefined, undefined, nIds.join(','))
				}
			}
		}
	}
</script>

<style scoped>
	.xiruiqueueBody {
		width: 100%;
		height: 100%;
		background-color: white;
	}
	
	.flexCenter>label {
		color: darkgray;
	}
	
	label.isGreen {
		color: green;
	}
	
	label.isRed {
		color: red;
	}
</style>